import { SweetAlertService } from './../../../../core/services/utils/sweet-alert.service';
import { LocalService } from './../../../../core/services/storage/local.service';
import { CountersService } from './../../../../core/services/utils/counters.service';
import { ModalPausaComponent } from './../modal-pausa/modal-pausa.component';
import { EmitService } from './../../../../core/services/utils/emit.service';
import { ModalService } from 'src/app/core/services/utils/modal.service';
import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { PausasService } from './../../../../core/services/http/pausas.service';

@Component({
  selector: 'app-modal-motivos-pausa',
  templateUrl: './modal-motivos-pausa.component.html',
  styleUrls: ['./modal-motivos-pausa.component.css']
})
export class ModalMotivosPausaComponent implements OnInit {
  detalle: any;
  tipo: any;
  listPausas: any;
  motivosForm!: FormGroup;
  motivoIsSubmitted = false;
  escritorio: any;
  idOficina = localStorage.getItem('idOficina');
  idEscritorio = localStorage.getItem('idEscritorio');
  respPausa: any;
  respErrPausa: any;

  constructor(
    private formBuilder: FormBuilder,
    private pausas: PausasService,
    private modalService: ModalService,
    private emit: EmitService,
    private counter: CountersService,
    private localSecureService: LocalService,
    private sweetAlertService: SweetAlertService
  ) { }

  ngOnInit(): void {
    this.escritorio = this.localSecureService.getValue('escritorio');
    this.setFormMotivoPausa();
    this.listaPausas();
  }

  setFormMotivoPausa() {
    this.motivosForm = this.formBuilder.group({
      motivo: [null, [Validators.required]]
    });
  }

  async listaPausas() {
    this.listPausas = await this.pausas.listaPausas();
  }

  async onSubmitMotivo() {
    if(!this.localSecureService.getValue('consultora')) {
      this.sweetAlertService.swalInternet();
      return;
    }
    
    this.motivoIsSubmitted = true;

    if (this.motivosForm.invalid) {
      return;
    }

    const dataPausa = {
      "idOficina": this.escritorio.idOficina,
      "idEscritorio": this.escritorio.idEscritorio,
      "tipoPausaId": this.motivosForm.value.motivo.idPausa
    }
    if (navigator.onLine) {
      await this.pausas.pausar(dataPausa).then((data) => {
        this.respPausa = data;
      });
      if (this.respPausa.info) {
        this.closeModal();
        this.sweetAlertService.swalLoading();
        switch (this.detalle) {
          case "En espera":
            this.counter.finEspera();
            this.emit.enviarData('sesion');
            break;
          case "Llamando":
            this.emit.enviarData('finTLlamado');
            break;
          case "Atendiendo":
            this.emit.enviarData('finTTurnoPausa');
            break;
        }
      } else{
        this.closeModal();
        this.emit.enviarData('failPausa');
      }
    } else {
      this.closeModal();
      this.emit.enviarData('noPausa');
    }

  }

  closeModal(): void {
    this.modalService.closeModal();
  }

  cerrar(){
    this.closeModal();
    if (this.tipo == 'derivar') {
      this.emit.enviarData('continuar');
    } else {
      switch (this.detalle) {
        case "En espera":
          this.emit.enviarData('sesion');
          break;
        case "Llamando":
            this.emit.enviarData('cierraPausa');
            break;
      }
    }
  }

  mostrarModalPausa(): void {
    const opciones = {
      class: '',
      initialState: {
      }
    };
    this.modalService.openModal(ModalPausaComponent, opciones);
  }

}
